
export { SchemaScript } from "./src/components/schema-script/SchemaScript"